import request from '@/utils/request'
import type {
  ApiResponse,
  EntityId,
  NoticeItem,
  NoticeTopResponse,
  PagedResponse,
  QueryParams,
  RequestPayload
} from '@/types/api'

export function listNotice(query: QueryParams = {}): Promise<PagedResponse<NoticeItem>> {
  return request<PagedResponse<NoticeItem>>({
    url: '/system/notice/list',
    method: 'get',
    params: query
  })
}

export function getNotice(noticeId: EntityId): Promise<ApiResponse<NoticeItem>> {
  return request<ApiResponse<NoticeItem>>({
    url: `/system/notice/${noticeId}`,
    method: 'get'
  })
}

export function addNotice(data: RequestPayload): Promise<ApiResponse> {
  return request<ApiResponse>({
    url: '/system/notice',
    method: 'post',
    data
  })
}

export function updateNotice(data: RequestPayload): Promise<ApiResponse> {
  return request<ApiResponse>({
    url: '/system/notice',
    method: 'put',
    data
  })
}

export function delNotice(noticeId: EntityId): Promise<ApiResponse> {
  return request<ApiResponse>({
    url: `/system/notice/${noticeId}`,
    method: 'delete'
  })
}

export function listNoticeTop() {
  return request<NoticeTopResponse>({
    url: '/system/notice/listTop',
    method: 'get'
  })
}

export function markNoticeRead(noticeId: EntityId): Promise<ApiResponse> {
  return request<ApiResponse>({
    url: '/system/notice/markRead',
    method: 'post',
    params: { noticeId }
  })
}

export function markNoticeReadAll(ids: EntityId[] | string): Promise<ApiResponse> {
  return request<ApiResponse>({
    url: '/system/notice/markReadAll',
    method: 'post',
    params: { ids }
  })
}

export function listNoticeReadUsers(query: QueryParams = {}): Promise<ApiResponse> {
  return request<ApiResponse>({
    url: '/system/notice/readUsers/list',
    method: 'get',
    params: query
  })
}
